"use strict";

var React = require("react"),
    PropTypes = require("prop-types"),
    classnames = require("classnames"),
    TextField = require("./TextField.js"),
    Dropdown = require("../dropdowns/Dropdown.js"),
    TextFieldWithDropdown = function TextFieldWithDropdown(e) {
  var p = classnames("blx-text-field-with-dropdown", e.className, {
    "blx-disabled": e.disabled
  });
  return React.createElement("div", {
    style: e.style,
    className: p
  }, React.createElement(TextField, e.textField), React.createElement(Dropdown, e.dropdown));
};

TextFieldWithDropdown.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  textField: PropTypes.shape({
    label: PropTypes.string,
    onChange: PropTypes.func,
    name: PropTypes.string,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    invalidErrorMessage: PropTypes.string,
    value: PropTypes.string,
    isValid: PropTypes.bool
  }),
  dropdown: PropTypes.shape({
    text: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      href: PropTypes.string,
      disabled: PropTypes.bool
    })),
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  })
}, TextFieldWithDropdown.defaultProps = {
  className: "",
  style: null,
  disabled: !1,
  textField: {
    label: null,
    onChange: function onChange() {},
    name: "",
    type: "text",
    placeholder: "Text input",
    invalidErrorMessage: "",
    value: "",
    isValid: !0
  },
  dropdown: {
    text: "Choose an option",
    onChange: function onChange() {},
    options: [],
    value: null
  }
}, module.exports = TextFieldWithDropdown;